import { HiOutlineSearch } from "react-icons/hi";
import { Input } from "../ui/input";
import useDebounce from "@utils/useDebounce"; 

const SearchInput = ({setCategory}: any) => {
  const handleSearch = useDebounce((value: string) => {
    setCategory(value);
  }, 1000); 

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    handleSearch(value);
  };

  return (
    <>
      <div className="relative">
        <Input
          className="h-12 bg-[#FFF] rounded-none border-none md:text-base text-sm focus-visible:ring-offset-0 focus-visible:ring-0 md:pl-12 pl-10 custom-placeholder-color"
          type="search"
          placeholder="Search Keywords, Categories etc."
          onChange={handleChange} // Use the debounced handleChange function
        />
        <HiOutlineSearch className="md:text-2xl text-xl text-[#BBBBBB] absolute top-3 left-3" />
      </div>
    </>
  );
};
export default SearchInput;
